export default __webpack_public_path__ + "static/media/Random_walk.5632a50c.png";